module.exports = __webpack_public_path__ + "static/media/gal-2.ee7b3ca7.jpeg";